<script>
  import { createEventDispatcher } from 'svelte'
  import { Buttons } from '../../elements'
  import { validateVipCoupon } from '../../api'

  let value = ''
  let checked = false
  let error = false
  let submitting = false

  const dispatch = createEventDispatcher()

  async function handleConfirm() {
    error = false
    submitting = true
    try {
      const r = await validateVipCoupon(value)
      submitting = false
      if (r.data.validateVipCoupon) {
        dispatch('redeem', { checked, code: r.data.validateVipCoupon.data.code })
      } else {
        error = true
      }
    } catch (e) {
      submitting = false
      error = true
    }
  }
</script>

<style>
  .title {
    font-size: 14px;
    line-height: 16px;
    color: #090a0b;
    margin-bottom: 8px;
    font-weight: bold;
  }
  .code-input {
    width: 100%;
    border: 1px solid #b1b5b9;
    border-radius: 5px;
    height: 48px;
    box-sizing: border-box;
    padding: 13px 12px;
  }
  .code-input.error {
    border-color: #d83b41;
  }
  .checkbox {
    margin-top: 22px;
    font-size: 14px;
    line-height: 18px;
  }
  .checkbox input {
    width: 16px;
    height: 16px;
    border: 1px solid #b1b5b9;
    border-radius: 2px;
    margin-right: 8px;
    display: inline-block;
    position: relative;
    top: 3px;
  }
  .checkbox label {
    display: inline-block;
  }
  p.error {
    font-size: 11px;
    line-height: 14px;
    color: #d83b41;
  }
</style>

<div class="wrapper">
  <label class="title" for="code-input">VIP Membership Code</label>
  <input
    placeholder="Please enter membership code here"
    id="code-input"
    class="code-input"
    class:error={error}
    bind:value
  />
  {#if error}
    <p class="error" data-test="redeem-error">*Wrong membership code</p>
  {/if}
  <p class="checkbox">
    <input type="checkbox" id="lifetime" bind:checked />
    <label for="lifetime">Add VIP as Lifetime Membership</label>
  </p>
</div>
<div class="button">
  <Buttons
    confirm="Validate Coupon Code"
    showCancel={false}
    on:confirm={handleConfirm}
    confirmDisabled={!value || submitting}
  />
</div>
